<template>
    <div>
        <div class="container ">
            <div class="title">筛选查询</div>
            <div class="center">
                 <e-search
                        :data="filterInfo.data"
                        :field-list="filterInfo.fieldList"
                         @handleFilter="handleFilter"
                         @handleReset="handleReset">
                 </e-search>
            </div>
        </div>
        <div class="container">
            <div class="title  line">送货人列表   <el-button type="primary" @click="addPerson">新增人员</el-button></div>
            <table-list
                    :loading="loading"
                    :table-data="tableData"
                    :table-label="tableLabel"
                    @handleButton="handleButton"
                    @handleSortChange="handleSortChange"
                    @handleSelectionChange="handleSelectionChange" class="margin-t10"
                    :index-show="indexShow">
                <template v-slot:operate="slot">
                    <div class="line">
                        <div @click="editPerson(slot.scope.row)" class="edit">编辑</div>
                        <div @click="deletePerson(slot.scope.row.id)" class="delete">删除</div>
                    </div>
                </template>
            </table-list>
            <div class="pagination">
                <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :page-sizes="[10, 20, 30, 40, 50, 60, 80, 100]"
                        layout="total, sizes, prev, pager, next, jumper"
                        :current-page="pageData.pageNum"
                        :page-size="pageData.pageSize"
                        :total="pageData.pageTotal" >
                </el-pagination>
            </div>
        </div>

        <div><e-dialog :dialogTitle="dialogTitle"
                               :centerDialogVisible="visible"
                               @updateVisible="updateVisible"
                               @resetPopupData="resetPopupData"
                               @submitPopupData="submitPopupData">
            <el-form
                    :inline="true"
                    :model="formData"
                    ref="shortForm"
                    class="form-inline"
                    label-width="90px">
                <el-form-item label="姓名:">
                    <el-input v-model="formData.deliName" placeholder="请输入姓名"></el-input>
                </el-form-item>
                <el-form-item label="电话:">
                    <el-input v-model="formData.deliPhone" placeholder="请输入电话"></el-input>
                </el-form-item>
                <el-form-item label="车牌号:">
                    <el-input v-model="formData.licensePlateNumber" placeholder="请输入车牌号"></el-input>
                </el-form-item>
            </el-form>
        </e-dialog>
        </div>
    </div>
</template>

<script>
    import tableList from "@/modules/projectA/components/common/e-table-list";
    import eSearch from "../../components/common/e-search"
    import eDialog from "@/components/common/epecDialog";
    import api from "../../api/order";

    export default {
        name: "selfConfigShipperMaintain",
        components: {tableList,eSearch,eDialog},
        data() {
            return {
                formData:{
                    deliName:'',
                    deliPhone:'',
                    licensePlateNumber:''
                },
                queryData:{
                    deliName:'',
                    deliPhone:'',
                 },
                dialogTitle:'',
                indexShow:true,
                visible:false,
                tableLabel: [
                    { label: "人员姓名", param: "deliName", align: "center"},
                    { label: "联系电话", param: "deliPhone", align: "center" },
                    { label: "车牌号", param: "licensePlateNumber", align: "center", },
                    { label: "操作", width: "90px", param: "operate", align: "center", slot:'operate'},
                ],
                tableData:[],
                loading: false,
                filterInfo: {
                    data: {deliName: null, deliPhone: null,},
                    fieldList: [
                        {label: "人员姓名", type: "input", value: "deliName"},
                        {label: "联系电话", type: "input", value: "deliPhone"}
                        ],
                    count: 100,
                    btnStyle: [{icon: "el-icon-search", text: "过滤", type: "primary"},
                        {icon: "el-icon-refresh", text: "重置"}
                    ]
                },
                pageData: {
                    pageNum: 1,
                    pageSize: 10,
                    pageTotal: 0
                },
            }
        },
        methods:{
            handleSizeChange(){},
            handleCurrentChange(num){
                 this.pageData.pageNum = num;
                 this.queryOrderDeliveryByPage();
            },
            updateVisible(){
                console.log('2')
            },
            resetPopupData(){
                this.visible = false;
            },
            //校验输入内容
            teatContent(){
                if(!this.formData.deliName){
                    this.$message.warning('送货人姓名不能为空。')
                    return false;
                }
                if(!this.formData.deliPhone){
                    this.$message.warning('送货人电话不能为空。')
                    return false;
                }
                if(!this.formData.licensePlateNumber){
                    this.$message.warning('送货人车牌号不能为空。')
                    return false;
                }
                if(this.formData.deliName.length < 2 || this.formData.deliName.length > 50){
                    this.$message.warning('送货人姓名长度不符合要求，仅可输入2-50个字符')
                    return false;
                }
                if(!(/^1[3|4|5|7|8]\d{9}$/.test(this.formData.deliPhone))){
                    this.$message.warning('请输入正确的手机号。')
                    return false;
                }
                if(this.formData.licensePlateNumber.length < 4 || this.formData.licensePlateNumber.length > 50){
                    this.$message.warning('送货人车牌号长度不符合要求，仅可输入4-50个字符')
                    return false;
                }

                return  true;
            },
            //确定新增
            submitPopupData(){
                if(!this.teatContent()){
                    return;
                }
                this.pageData.pageNum = 1;
                if(this.dialogTitle == '新增送货人'){
                    api.addOrderDelivery(this.formData).then((res)=>{
                        if(res.code == 200){
                            this.$message.success('新增送货人成功。')
                            this.queryOrderDeliveryByPage();
                            this.visible = false;
                            this.formData = {};
                        }
                    })
                }else{
                    api.modifyOrderDelivery({id:this.id,...this.formData}).then((res)=>{
                        if(res.code == 200){
                            this.$message.success('送货人信息修改成功。')
                            this.formData = {};
                            this.queryOrderDeliveryByPage();
                            this.visible = false;
                        }
                    })
                }

            },
            //新增人员
            addPerson(){
                this.dialogTitle = '新增送货人';
                this.visible = true;
            },
            //查询
            queryOrderDeliveryByPage(){
                api.queryOrderDeliveryByPage({...this.queryData,...this.pageData}).then((res)=>{
                    if(res.code == 200){
                        this.tableData = res.data.records;
                        this.pageData.pageTotal = res.data.total;
                     }
                })
            },
            //删除人员
            deletePerson(id){
                 this.$confirm(`是否删除此人员信息？`, "删除送货人", {confirmButtonText: "确定", cancelButtonText: "取消"}).then(async () => {
                     api.removeOrderDelivery({id:id}).then((res)=>{
                         if(res.code == 200){
                             this.$message.success('删除送货人成功。')
                             this.queryOrderDeliveryByPage();
                          }
                     })
                });
            },
            //编辑人员
            editPerson(param){
                this.dialogTitle = '编辑送货人';
                this.id = param.id;
                this.visible = true;
                this.formData = {
                        deliName:param.deliName,
                        deliPhone:param.deliPhone,
                        licensePlateNumber:param.licensePlateNumber
                };
            },
            //搜索查询
            handleFilter(val){
                this.queryData.deliName = val.deliName;
                this.queryData.deliPhone = val.deliPhone;
                 this.pageData.pageNum = 1;
                 this.queryOrderDeliveryByPage();
            },
            handleReset(val){
                console.log('c'+val)
            },
            handleButton(){},
            handleSortChange(){},
            handleSelectionChange(){}
        },
        mounted() {
            this.queryOrderDeliveryByPage();
        }
    }
</script>

<style scoped lang="scss">
    .title {
        font-size: 14px;
        color: #333;
        font-weight: bold;
    }
    .center{
        display: flex;
        justify-content: center;
    }
    .margin-t10{
        margin-top: 10px;
    }
    .line{
        display: flex;
        justify-content: space-between;
        align-items: center;
         .edit{
            cursor: pointer;
            color: #126EDF;
            border-bottom: 1px solid transparent;
            &:hover{
                border-bottom: 1px solid #126EDF;
            }
        }
        .delete{
            cursor: pointer;
            color: #EF4C56;
            border-bottom: 1px solid transparent;
            &:hover{
                border-bottom: 1px solid #EF4C56;
            }
        }
    }
    .form-inline{
        ::v-deep  .el-input__inner{
            width: 274px;
            height: 30px;
        }
    }
    .pagination {
        display: flex;
        justify-content: flex-end;
    }
</style>